const translations = {
  "en": {
    "Breaking News": "Breaking News",
    "Trending": "Trending"
  },
  "zh-tw": {
    "Breaking News": "即時新聞",
    "Trending": "趨勢"
  }
};

export default translations;
